import axios from "../../axios/axios";
import {
  JOB_LOAD_FAIL,
  JOB_LOAD_REQUEST,
  JOB_LOAD_SINGLE_FAIL,
  JOB_LOAD_SINGLE_REQUEST,
  JOB_LOAD_SINGLE_SUCCESS,
  JOB_LOAD_SUCCESS,
  JOB_CREATE_LOAD,
  JOB_CREATE_REQUEST,
  JOB_CREATE_SUCCESS,
  JOB_CREATE_FAIL,
} from "../constants/jobconstant";
import { toast } from "react-toastify";

export const createJobAction = (job, navigate) => async (dispatch) => {
  dispatch({ type: JOB_CREATE_LOAD });
  try {
    const data = await axios.post(`/api/jobs`, job);
    console.log(data);
    dispatch({
      type: JOB_CREATE_SUCCESS,
      payload: data.data,
    });
    toast.success("job created successfully!");
  } catch (error) {
    console.log(error);
    // dispatch({
    //   type: JOB_CREATE_FAIL,
    //   payload: error.response.data.message,
    // });
    // toast.error(error.response.data.message);
  }
};

export const jobLoadAction = () => async (dispatch) => {
  dispatch({ type: JOB_LOAD_REQUEST });
  try {
    const { data } = await axios.get(`/api/jobs`);
    console.log(data);
    dispatch({
      type: JOB_LOAD_SUCCESS,
      payload: data.data,
    });
  } catch (error) {
    dispatch({
      type: JOB_LOAD_FAIL,
      // payload: error.response.data.error,
    });
  }
};

//filter Jobs
export const filterJobs = (filter) => async (dispatch) => {
  dispatch({ type: JOB_LOAD_REQUEST });
  try {
    console.log(filter);
    const data = await axios.post("/api/jobs/filter", filter);
    console.log(data);
    dispatch({
      type: JOB_LOAD_SUCCESS,
      payload: data.data,
    });
  } catch (error) {
    console.log(error);
  }
};

// single job action
export const jobLoadSingleAction = (id) => async (dispatch) => {
  dispatch({ type: JOB_LOAD_SINGLE_REQUEST });
  try {
    const { data } = await axios.get(`/api/jobs/${id}`);
    dispatch({
      type: JOB_LOAD_SINGLE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: JOB_LOAD_SINGLE_FAIL,
      payload: error.response.data.error,
    });
  }
};
